import { Component } from '@ecs/Component';

export class Selectable implements Component {
  readonly type = 'Selectable';

  constructor(
    public selected: boolean = false
  ) {}
}
